import RequestPrescreenerBaseCategoryController from './prescreener--base-category';

export default class RequestPrescreenerBillingPayment extends RequestPrescreenerBaseCategoryController {}
